<template>
  <div class="quiz-container" ref="top">

    <div v-if="showMessage">
      <h2>Ai completat deja un chestionar. Mulțumim!</h2>
    </div>
    <div v-else>
      <h2>Chestionar despre piața de artă<br><small>(avem in vedere in special anul 2024-2025)</small></h2>

      <form @submit.prevent="submitQuiz">
        <div class="question" v-for="(question, qkey) in questions" :key="qkey">
          <h3>{{ question.label }}</h3>
          <div v-for="(option, index) in question.options" :key="index" class="option">
            <input
                type="checkbox"
                :id="`${qkey}_${index}`"
                :checked="isChecked(qkey, option)"
                @change="toggleOption(qkey, option)"
            />
            <label :for="`${qkey}_${index}`">{{ option }}</label>
          </div>
        </div>

        <button type="submit" :disabled="!isComplete">Trimite răspunsurile</button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    initialAnswers: {
      type: Object,
      default: () => ({})
    },
    alreadySubmitted: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showMessage: false,
      answerKeyMap: {
        q1: 'gender',
        q2: 'age',
        q3: 'occupation',
        q4: 'art_types',
        q5: 'acquisition_channels',
        q6: 'motivation',
        q7: 'investment_amount',
        q8: 'family_opinion',
        q9: 'art_destination',
        q10: 'market_level'
      },
      answers: {
        q1: '', q2: '', q3: '',
        q4: [], q5: [],
        q6: [], q7: '', q8: '', q9: '', q10: ''
      },
      questions: {
        q1: {
          label: "1. Genul",
          options: ["Masculin", "Feminin"]
        },
        q2: {
          label: "2. Vârsta",
          options: [
            "Foarte tânăr(ă): 18-30 ani",
            "Tânăr(ă): 31-50",
            "Adult(ă): 51-70",
            "Matur(ă): peste 70 de ani"
          ]
        },
        q3: {
          label: "3. Ocupația",
          options: [
            "Antreprenoriat",
            "Top management",
            "Corporate",
            "IT/Tehnologie",
            "Media/Comunicare",
            "Profesie liberală"
          ]
        },
        q4: {
          label: "4. Ce artă achiziționați cu precădere? (puteți bifa mai multe domenii)",
          options: [
            "Clasică",
            "Contemporană",
            "Decorativă",
            "Luxury (Ceasuri, Bijuterii, Accesorii)",
            "Istorică (Numismatică, Militaria, Hărți)",
            "Carte și autograf",
            "Tradițională și sacră",
            "Mașini clasice",
            "Băuturi de colecție",
            "Sports & Music Memorabilia"
          ]
        },
        q5: {
          label: "5. Care este principalul canal de achiziție? (puteți bifa mai multe domenii)",
          options: [
            "Licitații",
            "Ateliere",
            "Galerii",
            "Magazine și anticariate",
            "Schimburi între colecționari",
            "Târguri",
            "Diverse platforme online"
          ]
        },
        q6: {
          label: "6. Care este principalul motiv pentru care achiziționați artă? (puteți bifa mai multe domenii)",
          options: [
            "Consum cultural",
            "Contribuție la salvarea patrimoniului",
            "Educarea următoarei generații",
            "Mecenat",
            "Randament investițional",
            "Păstrarea valorii/tezaurizare",
            "Diversificare portofoliu",
            "Modă"
          ]
        },
        q7: {
          label: "7. Cât apreciați că ați investit în artă în ultimul an?",
          options: [
            "Sub 10.000 de euro",
            "10-50.000 de euro",
            "50-100.000 de euro",
            "100-500.000 de euro",
            "Peste 500.000 de euro"
          ]
        },
        q8: {
          label: "8. Ce părere are familia cu privire la exercițiul pasiunii Dvs. pentru artă?",
          options: [
            "Mă sprijină",
            "Mă acceptă",
            "Mă urmărește cu atenție și îngrijorare"
          ]
        },
        q9: {
          label: "9. Care este destinația artei pe care o colecționați?",
          options: [
            "Rămâne în familie",
            "Va fi donată unui muzeu",
            "Va fi vândută"
          ]
        },
        q10: {
          label: "10. Care credeți că este nivelul de dezvoltare al pieței românești de artă",
          options: [
            "Un timid început",
            "Tânără și emergentă",
            "Matură și deplin funcțională",
            "Și-a atins maximul potențial"
          ]
        }
      }
    };
  },
  computed: {
    isComplete() {
      return Object.entries(this.answers).every(([key, value]) =>
          Array.isArray(value) ? value.length > 0 : value !== ''
      );
    }
  },
  methods: {
    isChecked(qkey, option) {
      const val = this.answers[qkey];
      return Array.isArray(val) ? val.includes(option) : val === option;
    },
    toggleOption(qkey, option) {
      if (Array.isArray(this.answers[qkey])) {
        const index = this.answers[qkey].indexOf(option);
        if (index > -1) {
          this.answers[qkey].splice(index, 1);
        } else {
          this.answers[qkey].push(option);
        }
      } else {
        this.answers[qkey] = option;
      }
    },
    async submitQuiz() {
      try {
        const payload = {};
        Object.entries(this.answerKeyMap).forEach(([qKey, apiKey]) => {
          payload[apiKey] = this.answers[qKey];
        });

        await axios.post('/api/quiz', payload);
        this.showMessage = true;
        this.$nextTick(() => {
          if (this.$refs.top) {
            const offsetTop = this.$refs.top.offsetTop;
            window.scrollTo({
              top: offsetTop - 300,
              behavior: 'smooth'
            });
          }
        });
        alert('Vă mulțumim pentru participare! Răspunsurile dvs. au fost înregistrate.');
      } catch (error) {
        console.error('Eroare la trimiterea răspunsurilor:', error);
        alert('A apărut o eroare. Vă rugăm să încercați din nou.');
      }
    }
  },
  mounted() {
    if (this.alreadySubmitted) {
      this.showMessage = true;
    }
    if (this.initialAnswers) {
      Object.entries(this.answerKeyMap).forEach(([qKey, backendKey]) => {
        const val = this.initialAnswers[backendKey];
        if (val) {
          this.answers[qKey] = Array.isArray(this.answers[qKey]) ? [...val] : val;
        }
      });
    }
  }
};
</script>


<style scoped>
.quiz-container {
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  background: white;
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.question {
  margin-bottom: 30px;
  padding: 15px;
  background: #f8f8f8;
  border-radius: 8px;
}

h2 {
  text-align: center;
  margin-bottom: 30px;
}

h3 {
  margin-top: 0;
  margin-bottom: 15px;
}

.option {
  margin-bottom: 10px;
  display: flex;
  align-items: center;
}

input[type="checkbox"] {
  margin-right: 10px;
  width: 18px;
  height: 18px;
  cursor: pointer;
}

label {
  cursor: pointer;
  margin: 0 !important;
}

button {
  display: block;
  width: 100%;
  padding: 15px;
  background: #4CAF50;
  color: white;
  border: none;
  border-radius: 5px;
  font-size: 16px;
  cursor: pointer;
}

button:hover {
  background: #45a049;
}

button:disabled {
  background: #cccccc;
  cursor: not-allowed;
}
</style>
